<script>
import {h, resolveComponent} from "vue";

export default {
  name: 'cAddList',
  emits: ['addRow', 'removeRow', 'change', 'formCheck'],
  data() {
    return {
      newKey: '',
      newValue: '',
      isVariation: false,
      formCheck: true,
    };
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    headers: {
      type: Array,
      default: () => {
      },
    },
    alertMsg: {
      type: String,
      default: '',
    },
    actionBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    initItems() {
      const addRow = [...this.value];
      return addRow;
    },
  },
  methods: {
    addRow() {
      if (this.newKey.length === 0) {
        this.isVariation = true;
      } else {
        this.$emit('addRow');
      }
    },
    removeRow(item) {
      this.$emit('removeRow', item);
    },
    onInput(e, index, val) {
      this.value[index][val] = e;
      this.$emit('change', this.value[index]);
    },
    checkDisabled(header, index) {
      if (header.disabled) {
        if (typeof header.disabled === 'boolean') return true;
        else if (typeof header.disabled === 'function') {
          return header.disabled(index);
        } else return false;
      } else {
        return false;
      }
    },
    onValidate() {
      this.initItems.map((item, idx) => {
        this.headers.map(hitem => {
          this.$refs[`textfield_${hitem.value}_${idx}`] &&
          this.$refs[`textfield_${hitem.value}_${idx}`].isValid();
          this.$refs[`textarea_${hitem.value}_${idx}`] &&
          this.$refs[`textarea_${hitem.value}_${idx}`].isValid();
        });
      });
      this.formCheck = false;
      this.$emit('formCheck', this.formCheck);
    },
    onBlur(e, header, bidx) {
      this.formCheck = true;
      this.$emit('formCheck', this.formCheck);
      this.$refs[`textfield_${header.value}_${bidx}`] &&
      this.$refs[`textfield_${header.value}_${bidx}`].isValid();
      this.$refs[`textarea_${header.value}_${bidx}`] &&
      this.$refs[`textarea_${header.value}_${bidx}`].isValid();
      header.blur && header.blur(e, bidx);
    },
  },
  render() {
    const {actionBtn, headers, initItems, $theme, alertMsg, isVariation} = this;
    const legoDropdown = resolveComponent('lego-dropdown')
    const legoTextField = resolveComponent('lego-text-field')
    const legoIcon = resolveComponent('lego-icon')
    const cLabel = resolveComponent('c-label')
    const legoTooltip = resolveComponent('lego-tooltip')
    const fieldType = (bidx, header, item) => {
      const dropdownBox = h(legoDropdown, {
        md: true,
        items: header.items,
        modelValue: item[header.value],
        placeholder: header.placeholder,
        'onUpdate:modelValue': e => this.onInput(e, bidx, header.value),

      });
      const textBpx = h(legoTextField, {
        md: true,
        disabled: this.checkDisabled(header, bidx),
        modelValue: item[header.value],
        placeholder: header.placeholder,
        rules: header.validate && header.validate(bidx),
        counter: header.maxLength,
        isCounter: header.counter || false,
        clearable: header.clearable || true,
        lazy: true,
        ref: `textfield_${header.value}_${bidx}`,
        onBlur: e => this.onBlur(e, header, bidx),
        'onUpdate:modelValue': e => this.onInput(e, bidx, header.value),
      });

      const textArea = h(legoTextField, {
        md: true,
        textarea: true,
        disabled: header.disabled,
        modelValue: item[header.value],
        placeholder: header.placeholder,
        rules: header.validate && header.validate(bidx),
        counter: header.maxLength,
        isCounter: header.counter || false,
        lazy: true,
        ref: `textarea_${header.value}_${bidx}`,
        onBlur: e => this.onBlur(e, header, bidx),
        'onUpdate:modelValue': e => this.onInput(e, bidx, header.value),
      });
      if (header.type === 'dropdown') return dropdownBox;
      else if (header.type === 'textfield') return textBpx;
      else if (header.type === 'textarea') return textArea;
      return textBpx;
    };

    const itemList = initItems.map((item, bidx) =>
        h(
            'div',
            {
              class: 'c-add-list-body__row',
            },
            [
              h(
                  'div',
                  {
                    class: 'c-add-list-body__action',
                    style: {
                      width: this.actionBtn ? '32px' : 0,
                      flex: this.actionBtn ? `0 0 32px` : 0,
                    },
                  },
                  [
                    actionBtn &&
                    h(legoIcon, {
                      iconType: 'df',
                      icon: 'delete_box_solid_24',
                      size: 24,
                      onClick: () => this.removeRow(item),
                    }),
                  ],
              ),
              headers.map((header, index) => {
                return h(
                    'div',
                    {
                      class: 'c-add-list-body__item',
                      style: {
                        width: header.width || '100%',
                        flex: header.width ? `0 0 ${header.width}` : '100%',
                        marginLeft: header.text ? '36px' : 0,
                      },
                    },
                    [
                      this.$slots.items
                          ? this.$slots.items({
                            item: item[header.value],
                            header: header,
                            index: bidx,
                          })
                          : h(
                              'div',
                              {
                                class: 'c-add-list-body__key',
                                style: {
                                  width: header.text || '24px',
                                  flex: header.text || `0 0 24px`,
                                },
                              },
                              [
                                h(
                                    cLabel,
                                    {
                                      weight: 700,
                                      inline: true,
                                      ellipsis: true,
                                      required: header.required,
                                      color: $theme.COLOR.UI.UI02,
                                    },
                                    () => [header.text],
                                ),
                                header.help &&
                                h('span', {class: 'help'}, [
                                  h(legoIcon, {
                                    iconType: 'df',
                                    icon: 'info',
                                    size: 16,
                                    id: 'manual',
                                  }),
                                  h(legoTooltip, {top: true, mouseOver: true}, () => [
                                    header.help,
                                  ]),
                                ]),
                              ],
                          ),
                      h(
                          'div',
                          {
                            class: 'c-add-list-body__data',
                          },
                          [fieldType(bidx, header, item)],
                      ),
                    ],
                );
              }),
            ],
        ),
    );

    const rowListBody = h(
        'div',
        {
          class: 'c-add-list-body',
        },
        [
          itemList,
          alertMsg &&
          isVariation &&
          h(
              'div',
              {
                class: {
                  'alert-msg': true,
                },
              },
              [
                h(legoIcon, {
                  iconType: 'df',
                  icon: 'warning',
                  size: 16,
                }),
                alertMsg,
              ],
          ),
        ],
    );

    return h(
        'div',
        {
          class: {
            'c-add-list': true,
          },
        },
        [rowListBody],
    );
  },
};
</script>
<style lang="scss" scoped>
.c-add-list {
  &-body {
    border-top: 1px solid $color--ui03;
    border-bottom: 1px solid $color--ui05;

    &:empty {
      border: 0;
    }

    &__key {
      width: 120px;
      padding-top: 6px;

      &:empty {
        width: 0;
      }

      .help {
        position: relative;
        top: 2px;
        left: 4px;
      }
    }

    &__data {
      width: calc(100% - 120px);
    }

    &__row {
      width: 100%;
      display: flex;
      align-items: flex-start;
      padding: 20px 0;
      border-bottom: 1px solid $color--ui08;

      &:nth-last-of-type(1) {
        border-bottom: 0;
      }
    }

    &__action {
      padding-top: 4px;
    }

    &__item {
      display: flex;
      align-items: flex-start;
      margin: 0 4px;
      margin-right: 120px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      .lego-text-field,
      .lego-dropdown {
        min-width: 100%;
      }

      .lego-button {
        width: 62px;
        flex: 0 0 62px;
        margin-left: 8px;
      }
    }

    .alert-msg {
      display: flex;
      align-items: center;
      color: $color--status--error;
      margin-top: 10px;

      :deep .lego-icon {
        margin-right: 5px;
      }
    }
  }
}
</style>
